import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HeroImageComponent } from 'src/app/shared/hero-image/hero-image.component';
import { PageLayoutBaseComponent } from '../page-layout-base.component';
import { PDFDocuments } from 'src/app/types/PDFDocuments';
import { AppService } from 'src/app/app.service';
import { AdobePdfService } from 'src/app/services/adobe-pdf.service';
import { PdfViewerComponent } from 'src/app/shared/pdf-viewer/pdf-viewer.component';

@Component({
  selector: 'app-environmental',
  imports: [HeroImageComponent, PdfViewerComponent],
  templateUrl: './environmental.component.html',
  styleUrl: './environmental.component.scss',
})
export class EnvironmentalComponent
  extends PageLayoutBaseComponent
  implements OnInit, AfterViewInit
{
  pdfDocuments: PDFDocuments[] = [];

  constructor(
    protected override appService: AppService,
    private adobePdfService: AdobePdfService
  ) {
    super(appService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.pdfDocuments = [
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/NEPA-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/environmental/NEPA-09-23-2025.pdf',
        title: 'NEPA Process',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Noise-Evaluation-Process-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/environmental/Noise-Evaluation-Process-09-23-2025.pdf',
        title: 'Noise Evaluation',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Visual-Impacts-Assessment-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/environmental/Visual-Impacts-09-23-2025.pdf',
        title: 'Visual Impacts',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/ROW-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/environmental/ROW-09-23-2025.pdf',
        title: 'Right of Way',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Environmental-Technical-Study-Area-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/environmental/Environmental-Technical-Study-Area-09-23-2025.pdf',
        title: 'Environmental Technical Study Area',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Views-from-and-of-the-Road-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/environmental/Views-of-the-and-from-the-Road-09-23-2025.pdf',
        title: 'Views of the Road vs Views from the Road',
      },
    ];
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.adobePdfService.embedMultiplePdfs(this.pdfDocuments);
    }, 100);
  }
}
